import { TimelineMax, TweenLite } from "gsap";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";

export class RevealerFull extends BaseView {

    protected lever:Sequence;
    protected animReaveal:Sequence;
    protected animFX:Sequence;

    protected _timeLine:TimelineMax;

    constructor (){
        super();
    }

    protected initAnimations():void{
      
        this.animReaveal = this.createSeq(GameResources.getTextures("XMelt"));
        this.animReaveal.scale.set(2,2);

        this.lever = this.createSeq(GameResources.getTextures("Lever"));

        this.animFX = this.createSeq(GameResources.getTextures("XElectro"));
        this.animFX.blendMode = PIXI.BLEND_MODES.ADD;
        this.animFX.scale.set(2,2);

        this.children.forEach(c => c.alpha = 0)
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FEATURE.name).addChild(this);
    }

    private createSeq(texture?:PIXI.Texture[]):Sequence{
        const seq:Sequence =  Sequence.createSequence(texture);
        seq.alpha = 1;
        seq.anchor.set(0.5,0.5);
        this.addChild(seq);
        return seq;
    }

    public get revealDurr():number{
        return Math.max(this.animReaveal.totalDuration,this.animFX.totalDuration);
    }

    public reveal():TimelineMax{

        let leverAnimationDurr =  this.lever.totalDuration;
        const revealDurr:number = this.revealDurr;

        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax({
            onComplete:() => this.children.forEach(c => c.alpha = 0)
        }));
        
        this._timeLine.add(this.lever.playAnimation({onStart:() => this.lever.alpha = 1}));
        this._timeLine.to(this.animReaveal,leverAnimationDurr/2,{alpha:1},leverAnimationDurr/2);
        
        this._timeLine.add([
            () => this.animFX.alpha = 1,
            this.animReaveal.playAnimation(),
            this.animFX.playAnimation(),
            TweenLite.to(this.lever,revealDurr/3,{alpha:0})
        ])

        return this._timeLine;
    }

    public close():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine,new TimelineMax());
        return this._timeLine;
    }
}